import * as React from 'react';
export var IconChevronUp = React.forwardRef(function IconChevronUp({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M7.47 5.718a.75.75 0 0 1 1.06 0l3.502 3.502a.75.75 0 1 1-1.06 1.06L8 7.31l-2.972 2.97a.75.75 0 0 1-1.06-1.06L7.47 5.718Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M11.72 8.72a.75.75 0 0 1 1.06 0l5.5 5.5a.75.75 0 1 1-1.06 1.06l-4.97-4.97-4.97 4.97a.75.75 0 0 1-1.06-1.06l5.5-5.5Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M11.72 8.72a.75.75 0 0 1 1.06 0l5.5 5.5a.75.75 0 1 1-1.06 1.06l-4.97-4.97-4.97 4.97a.75.75 0 0 1-1.06-1.06l5.5-5.5Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
